<template>
    <div class="table-action-buttons">
        <Button 
            v-for="(action, index) in actions" 
            :key="index"
            :type="action.type"
            :size="action.size"
            :icon="action.icon"
            @click="action.onClick"
            :style="{ marginRight: index < actions.length - 1 ? '5px' : '0' }"
        >
            {{ action.text }}
        </Button>
    </div>
</template>

<script>
export default {
    name: 'TableActionButtons',
    props: {
        actions: {
            type: Array,
            default: () => []
        }
    }
};
</script>

<style lang="less" scoped>
.table-action-buttons {
    display: flex;
    gap: 8px;
    justify-content: center;

    button {
        border-radius: 6px;
        transition: all 0.3s ease;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);

        &:hover {
            transform: translateY(-1px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        }
    }
}
</style>